import React, { useEffect, useState } from "react";
import "./style.css";
import AddNewCard from "./component/AddNewCardModal";
import { useUsersContext } from "../../../../context/usersContext";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useActiveAccountPlan, useCancelUserSubscription } from "../../../../queries/billing";
import ViewModel from "./component/ViewModel/index"
import CancelModal from "./component/CancelModal/CancelModal"
import { useUserInfo } from "../../../../context/user";
import toast from "react-hot-toast";
function BillingContent() {
  const currencySymbols = [
    {
      "label": "usd",
      "value": "$"
    },
    {
      "label": "eur",
      "value": "€"
    },
    {
      "label": "jpy",
      "value": "¥"
    },
    {
      "label": "gbp",
      "value": "£"
    },
    {
      "label": "aud",
      "value": "A$"
    },
    {
      "label": "cad",
      "value": "C$"
    },
    {
      "label": "chf",
      "value": "Fr"
    },
    {
      "label": "cny",
      "value": "¥"
    },
    {
      "label": "sek",
      "value": "kr"
    },
    {
      "label": "nzd",
      "value": "NZ$"
    },
    {
      "label": "krw",
      "value": "₩"
    },
    {
      "label": "sgd",
      "value": "S$"
    },
    {
      "label": "nok",
      "value": "kr"
    },
    {
      "label": "mxn",
      "value": "Mex$"
    },
    {
      "label": "inr",
      "value": "₹"
    },
    {
      "label": "rub",
      "value": "₽"
    },
    {
      "label": "zar",
      "value": "R"
    },
    {
      "label": "try",
      "value": "₺"
    },
    {
      "label": "brl",
      "value": "R$"
    },
    {
      "label": "twd",
      "value": "NT$"
    },
    {
      "label": "dkk",
      "value": "kr"
    },
    {
      "label": "pln",
      "value": "zł"
    },
    {
      "label": "thb",
      "value": "฿"
    },
    {
      "label": "idr",
      "value": "Rp"
    },
    {
      "label": "huf",
      "value": "Ft"
    },
    {
      "label": "czk",
      "value": "Kč"
    },
    {
      "label": "ils",
      "value": "₪"
    },
    {
      "label": "clp",
      "value": "CLP$"
    },
    {
      "label": "php",
      "value": "₱"
    },
    {
      "label": "aed",
      "value": "د.إ"
    },
    {
      "label": "cop",
      "value": "COL$"
    },
    {
      "label": "sar",
      "value": "﷼"
    },
    {
      "label": "myr",
      "value": "RM"
    },
    {
      "label": "ron",
      "value": "lei"
    },
    {
      "label": "pkr",
      "value": "₨"
    },
    {
      "label": "vnd",
      "value": "₫"
    },
    {
      "label": "ngn",
      "value": "₦"
    },
    {
      "label": "egp",
      "value": "E£"
    },
    {
      "label": "bdt",
      "value": "৳"
    },
    {
      "label": "pyg",
      "value": "₲"
    },
    {
      "label": "irr",
      "value": "﷼"
    },
    {
      "label": "iqd",
      "value": "ع.د"
    },
    {
      "label": "dzd",
      "value": "DA"
    },
    {
      "label": "kwd",
      "value": "ك"
    },
    {
      "label": "uah",
      "value": "₴"
    },
    {
      "label": "hrk",
      "value": "kn"
    },
    {
      "label": "omr",
      "value": "﷼"
    },
    {
      "label": "tnd",
      "value": "د.ت"
    },
    {
      "label": "qar",
      "value": "﷼"
    },
    {
      "label": "crc",
      "value": "₡"
    },
    {
      "label": "ars",
      "value": "AR$"
    },
    {
      "label": "lkr",
      "value": "₨"
    },
    {
      "label": "vnd",
      "value": "₫"
    },
    {
      "label": "mad",
      "value": "د.م."
    },
    {
      "label": "npr",
      "value": "रू"
    },
    {
      "label": "uzs",
      "value": "сўм"
    },
    {
      "label": "mvr",
      "value": "ރ."
    },
    {
      "label": "jod",
      "value": "د.ا"
    },
    {
      "label": "bhd",
      "value": "ب.د"
    },
    {
      "label": "kzt",
      "value": "₸"
    },
    {
      "label": "byn",
      "value": "Br"
    },
    {
      "label": "lbp",
      "value": "ل.ل."
    },
    {
      "label": "gtq",
      "value": "Q"
    },
    {
      "label": "ttd",
      "value": "TT$"
    },
    {
      "label": "svc",
      "value": "₡"
    },
    {
      "label": "afn",
      "value": "؋"
    },
    {
      "label": "yer",
      "value": "﷼"
    },
    {
      "label": "bob",
      "value": "Bs"
    },
    {
      "label": "bmd",
      "value": "BD$"
    },
    {
      "label": "bzd",
      "value": "BZ$"
    },
    {
      "label": "xcd",
      "value": "EC$"
    },
    {
      "label": "gel",
      "value": "₾"
    },
    {
      "label": "jmd",
      "value": "J$"
    },
    {
      "label": "kyd",
      "value": "KY$"
    },
    {
      "label": "mnt",
      "value": "₮"
    },
    {
      "label": "nad",
      "value": "N$"
    },
    {
      "label": "pab",
      "value": "B/."
    },
    {
      "label": "sdg",
      "value": "ج.س."
    },
    {
      "label": "sdp",
      "value": "£S"
    },
    {
      "label": "lvl",
      "value": "Ls"
    },
    {
      "label": "ltl",
      "value": "Lt"
    },
    {
      "label": "zwd",
      "value": "Z$"
    },
    {
      "label": "awg",
      "value": "Afl."
    },
    {
      "label": "bbd",
      "value": "Bds$"
    },
    {
      "label": "bgn",
      "value": "лв"
    },
    {
      "label": "cdf",
      "value": "FC"
    },
    {
      "label": "xof",
      "value": "CFA"
    },
    {
      "label": "djf",
      "value": "Fdj"
    },
    {
      "label": "fkp",
      "value": "FK£"
    },
    {
      "label": "gip",
      "value": "GIP"
    },
    {
      "label": "gnf",
      "value": "FG"
    },
    {
      "label": "htg",
      "value": "HTG"
    },
    {
      "label": "iqd",
      "value": "ع.د"
    },
    {
      "label": "irr",
      "value": "﷼"
    },
    {
      "label": "isk",
      "value": "kr"
    },
    {
      "label": "lak",
      "value": "₭"
    },
    {
      "label": "lsl",
      "value": "LSL"
    },
    {
      "label": "mmk",
      "value": "K"
    },
    {
      "label": "mro",
      "value": "UM"
    },
    {
      "label": "mzn",
      "value": "MT"
    },
    {
      "label": "nio",
      "value": "C$"
    },
    {
      "label": "pgk",
      "value": "PGK"
    },
    {
      "label": "rwf",
      "value": "R₣"
    },
    {
      "label": "shp",
      "value": "£"
    },
    {
      "label": "std",
      "value": "Db"
    },
    {
      "label": "szl",
      "value": "E"
    },
    {
      "label": "top",
      "value": "T$"
    },
    {
      "label": "ugx",
      "value": "USh"
    },
    {
      "label": "vuv",
      "value": "VT"
    },
    {
      "label": "wst",
      "value": "WS$"
    },
    {
      "label": "xaf",
      "value": "FCFA"
    },
    {
      "label": "xpf",
      "value": "F"
    },
    {
      "label": "zmw",
      "value": "ZK"
    }
  ]
  const { getLocationUsers, companyInfo, agency } = useUsersContext();
  const active_location = useUserInfo()[4];
  const [activeplan, setActiveplan] = useState([]);
  const [viewmodelstate, setViewModelstate] = useState(false);
  const [viewmodeldata, setViewModeldata] = useState(false);
  const [addAddUerModalOpen, setAddUserModalOpen] = useState(false);

  let stripePromise = "";
  if (agency?.stripe?.publish_key !== undefined) {
    stripePromise = loadStripe(agency?.stripe?.publish_key);
  }
  const [formData, setFormData] = useState({
    username: "",
    lastName: "",
    email: "",
    contactNumber: "",
  });

  const {
    data: activePlanData,
    refetch: refetchActiveAccountPlan,
  } = useActiveAccountPlan();

  const justCloseIt = () => {
    setopencancelmodal(false);
    setAddUserModalOpen(false);
    setViewModelstate(false);
    refetchActiveAccountPlan();
  };

  const handleAddUserModal = (e) => {
    e.preventDefault();
    setAddUserModalOpen(true);
  };
  const [plans, setPlans] = useState([]);
  const [activeaccount, setActiveaccount] = useState({});
  const [currencyName, setCurrencyName] = useState();
  const [cardmode, setcardmode] = useState(null);

  useEffect(() => {
    if (!activePlanData) return;
    setActiveaccount(activePlanData.account_with_match_plans?.account);
    setActiveplan(activePlanData.account_with_match_plans?.matchedSaasPlans[0]);
    setPlans(activePlanData?.saasplans);
    const currencyName = activePlanData?.agencycurriency.filter(item => item?._id === activePlanData.account_with_match_plans?.matchedSaasPlans[0]?.category?.categorySelected);
    setCurrencyName(currencyName);
    setcardmode(activePlanData?.matchagency_strip?.card[0]?.brand);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePlanData]);

  const openViewModel = (item) => {
    setViewModelstate(true);
    setViewModeldata(item)

  }
  const [opencancelmodal, setopencancelmodal] = useState(false)

  const cancelUserSubscription = useCancelUserSubscription();

  const cancelsubscription = async () => {
    const payload = {
      activelocation: active_location._id
    };

    try {
      await cancelUserSubscription.mutateAsync(payload);

      try {
        toast.success('Your account cancellation is now being processed', {
          duration: 2000,
        });

        setTimeout(() => {
          toast.success('You will receive a confirmation email once the cancellation is complete', {
            duration: 2000,
          });
        }, 2000);
      } catch (toastError) {
        console.error("Toast display failed:", toastError);
      }

    } catch (error) {
      try {
        const message = error?.response?.data?.message || "Something went wrong";
        toast.error(message);
      } catch (toastError) {
        console.error("Toast error handling failed:", toastError);
      }
    }
  };


  function getCurrencySymbol(label) {
    const currency = currencySymbols.find(item => item.label === label);
    return currency ? currency.value : null;  // Return the symbol if found, else null
  }
  return (
    <div className="settingsPage form-border">
      <div className="pageHeader">
        <div className="page-header [&_.page-display]:text-3xl [&_.page-display]:md:text-4xl [&_.page-lede]:text-sm pb-4">
          <span className="page-eyebrow">Configure</span>
          <h1 className="page-display">
            Billing. <span className="accent block md:inline">Your plan, payment, and invoices.</span>
          </h1>
          <p className="page-lede">Manage your subscription, update payment details, and download past invoices.</p>
        </div>

        {stripePromise &&
          <button
            className="btn addUserBtn"
            onClick={(e) => handleAddUserModal(e)}
          >
            Add New Card
          </button>
        }
      </div>
      <div style={{ display: 'flex' }}>
        <div className="card1Active">
          <h2 className="my-1 text-center"><span className="heading-modeldesc">Active Plan Detail</span></h2>

          <h2 className="my-1"><span className="heading-modeldesc">Name : </span> {activeplan?.product_name}</h2>
          {activeplan?.monthly_amount && (
            <h2 className="my-1"><span className="heading-modeldesc">Monthly : </span>{getCurrencySymbol(plans?.find(item => item?._id === activeplan?._id)?.category?.crncy_symbol)}{activeplan?.monthly_amount / 100}</h2>
          )}
          {activeplan?.yearly_amount && (
            <h2 className="my-1"><span className="heading-modeldesc">Yearly : </span> {getCurrencySymbol(plans?.find(item => item?._id === activeplan?._id)?.category?.crncy_symbol)}{activeplan?.yearly_amount / 100}</h2>
          )}
          {/* <h2 className="my-1"><span className="heading-modeldesc">Active :</span> {activeaccount?.plan_type}</h2> */}
          {active_location.status === 'cancel_request' ?
            <button className="saveButton" style={{ padding: '6px 20px', background: '#c31111' }} >Subscription Cancelled</button>
            : <button className="saveButton" onClick={cancelsubscription} style={{ padding: '6px 20px', background: '#c31111' }} >Cancel Subscription</button>
          } </div>

      </div>
      <h2 style={{ margin: "20px 0px", fontSize: "20px", fontWeight: "bold" }}>
        Plans
      </h2>
      <div className="main-div">
        {plans.length > 0 && plans.filter(item => item.isenable_account === true).map((item, index) => (
          (item?._id !== activeplan?._id && (
            <div class="plansmaindi py-2 my-4">
              <div class="fixinnerposition">

                <div><h2>Name : {item?.plan?.plan_name || item.product_name}</h2>
                  {item?.monthly_amount && (
                    <p>Monthly price : {getCurrencySymbol(item?.category?.crncy_symbol)}{item?.monthly_amount / 100}</p>
                  )}
                  {item?.yearly_amount && (
                    <p>Yearly price : {getCurrencySymbol(item?.category?.crncy_symbol)}{item?.yearly_amount / 100}</p>
                  )}
                </div>
                <div className="pt-4">
                  <button className="saveButton" style={{ padding: '6px 20px', background: '#c31111' }} onClick={() => openViewModel(item)}>View</button>
                </div>
              </div>
            </div>
          ))
        ))}
      </div>
      {viewmodelstate &&
        <ViewModel
          isModalOpen={viewmodelstate}
          justCloseIt={justCloseIt}
          data={viewmodeldata}
          getCurrencySymbol={getCurrencySymbol}
        />
      }
      {opencancelmodal && (
        <CancelModal
          isModalOpen={opencancelmodal}
          justCloseIt={justCloseIt}
          activelocation={active_location}
        />
      )}

      {stripePromise &&
        <Elements stripe={stripePromise}>
          <AddNewCard
            isModalOpen={addAddUerModalOpen}
            justCloseIt={justCloseIt}
            getLocationUsers={getLocationUsers}
          />
        </Elements>
      }
    </div>
  );
}

export default BillingContent;
